import { getResponseQuery } from "../../helpers/_functions";
import http from "../../http-common";
import BaseService from "../base.service";

class EvaluationCriteriaGroup extends BaseService {
  constructor() {
    super("evaluation-criteria-group");
  }

  createEvaluationCriteriaGroup = (data) =>
    getResponseQuery(super.insert(data));

  updateEvaluationCriteriaGroup = (evaluationCriteriaGroup) =>
    getResponseQuery(super.updateById(evaluationCriteriaGroup));

  deleteEvaluationCriteriaGroup = (evaluationCriteriaGroupId) =>
    getResponseQuery(super.deleteById(evaluationCriteriaGroupId));

  updateOrderEvaluationCriteriaGroup = (
    enterpriseId,
    arrayEvaluationCriteriaGroups
  ) =>
    getResponseQuery(
      http.post(
        `${this.path}/update-order/${enterpriseId}`,
        arrayEvaluationCriteriaGroups
      )
    );

  getGroupEvaluationCriteria = (evaluationCriteriaGroupId) =>
    getResponseQuery(
      http.get(
        `${this.path}/get-group-with-evaluationCriterias/${evaluationCriteriaGroupId}`
      )
    );

  getAllGroupEvaluationCriteria = (enterpriseId) =>
    getResponseQuery(http.get(`${this.path}/get-groups/${enterpriseId}`));
}

export default new EvaluationCriteriaGroup();
